var Tools = require('../../deploynaut/js/tools.jsx');

var WAFConfig = require('./WAFConfig.jsx');

Tools.install(WAFConfig, 'WAFConfig');
